﻿import * as React from "react";

export interface IBannerButtonProps {
    title: string;
    onClick: () => void;
    isActive: boolean;
}

export const BannerButton: React.FunctionComponent<IBannerButtonProps> = (
    props,
): React.ReactElement => {
    const classString = `BannerButton ${props.isActive ? `active` : ``}`;

    return (
        <div className={classString} onClick={props.onClick}>
            {props.title}
        </div>
    );
};
